import { toast } from "react-toastify";
import Api from "../../../axios";
import { callLoader } from "../../../common/actions/app";

let ACTION_LOCATION_LIST = {
    type: 'LOCATION_LIST',
    payload: {
        rows: [],
        total: 0,
        pagination: [],
    },
};

let ACTION_LOCATION_VIEW = {
    type: 'LOCATION_VIEW',
    payload: {
        companyId: '',
        categoryId: '',
        regionId: '',
        code: '',
        name: '',
    },
};

let callLocationListGet = (filter = {}, pg = 1) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/locations?pg=' + pg).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_LOCATION_LIST.payload.rows = data.rows
        ACTION_LOCATION_LIST.payload.total = data.total
        ACTION_LOCATION_LIST.payload.pagination = data.pagination
        dispatch(ACTION_LOCATION_LIST)
    })
}

let callLocationViewGet = (id) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/locations/' + id).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_LOCATION_VIEW.payload.companyId = data.companyId
        ACTION_LOCATION_VIEW.payload.categoryId = data.categoryId
        ACTION_LOCATION_VIEW.payload.regionId = data.regionId ? data.regionId : ''
        ACTION_LOCATION_VIEW.payload.code = data.code
        ACTION_LOCATION_VIEW.payload.name = data.name
        dispatch(ACTION_LOCATION_VIEW)
    })
}

let callLocationPost = (data, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.post('/locations', data).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callLocationPut = (id, data, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.put('/locations/' + id, data).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callLocationClearView = () => (dispatch) => {
    ACTION_LOCATION_VIEW.payload.companyId = ''
    ACTION_LOCATION_VIEW.payload.categoryId = ''
    ACTION_LOCATION_VIEW.payload.regionId = ''
    ACTION_LOCATION_VIEW.payload.code = ''
    ACTION_LOCATION_VIEW.payload.name = ''
    dispatch(ACTION_LOCATION_VIEW)
}

let callLocationDelete = (id, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.delete('/locations/' + id).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

export { callLocationListGet, callLocationViewGet, callLocationPost, callLocationPut, callLocationDelete, callLocationClearView, ACTION_LOCATION_LIST, ACTION_LOCATION_VIEW }